interface Location {
  code: string;
  name: string;
  currency: string;
}

interface Offer {
  id: number;
  text: string;
  lang_code: string;
}

export enum PaymentMethodEnum {
  reception = 'reception',
  paymentSystem = 'payment_system',
  roomBill = 'room_bill',
  vipAccess = 'vip_access',
}

export enum DevicePaymentMethodEnum {
  paymentSystemEmail = 'payment_system_email',
  paymentSystemMobile = 'payment_system_mobile',
  roomBill = 'room_bill',
  qrCode = 'qr_code',
  mobile = 'mobile',
}

enum ContractType {
  leaseContract = 'lease_contract',
  agencyContract = 'agent_contract',
  mixedContract = 'mixed_contract',
  serviceAgreement = 'service_contract',
}

interface CompanyDetails {
  id: string;
  legalEntityName: string;
  legalEntityAddress: string;
  address: string;
  contractLabel: string;
  contractType: ContractType;
  contractSigningDate: string;
  contractExpirationDate: string;
  agentCommission: number;
  headsets: number;
  contacts: string;
}

export interface Company {
  id: string;
  name: string;
  createdAt: string;
  paymentMethods: PaymentMethodEnum[];
  isTest: boolean;
  isActive: boolean;
  location?: Location;
  offers?: Offer[];
  activatedAt?: string;
  devicePaymentMethods: DevicePaymentMethodEnum[];
  details: CompanyDetails[];
  todayPaymentCount: number;
  headsets: number;
  needCustomerSession: boolean;
  commission: number;
  image: string | null;
}
